module.exports = __webpack_public_path__ + "static/img/A32.be9e7bab.jpg";